import Vue from 'vue'
import { QueryComponents, QueryStatus, QueryIncidents, QueryIncident, QueryReport, QueryLastest, QueryMessages, QueryListIncidents } from '../resource/index.js'

export let actions = {
    initalize: ({ commit }) => {
        commit('SET_IS_LOADING', true)

        Promise.all([
            QueryComponents.get(),
            QueryStatus.get()
        ]).then((data) => {
            commit('SET_COMPONENTS', data[0].data.components)
            commit('SET_EMAIL_USE_TEMPLATE', data[0].data.email_use_template)
            commit('SET_STATUS', data[1].data)
            commit('SET_IS_LOADING', false)
        }, (errorResponse) => {
            commit('SET_IS_LOADING', false)
        })
    },
    loadIncident: ({ commit, getters }, incidentId) => {
        Vue.http.headers.common.Authorization = getters.getAuthenticationHeader

        commit('SET_IS_LOADING', true)
        return QueryIncident.get({ id: incidentId }).then((response) => {
            setTimeout(function () {
                commit('SET_INCIDENT', response.body)
                commit('SET_IS_LOADING', false)
            }, 400)
        }, (errorResponse) => {
            commit('SET_IS_LOADING', false)
        })
    },
    loadLatestIncidents: ({ commit }) => {
        commit('SET_IS_LOADING', true)
        return QueryLastest.get().then((response) => {
            setTimeout(function () {
                commit('SET_LATEST_INCIDENTS', response.body)
                commit('SET_IS_LOADING', false)
            }, 400)
        }, (errorResponse) => {
            commit('SET_IS_LOADING', false)
        })
    },
    loadIncidents: ({ commit }, type) => {
        commit('SET_IS_LOADING', true)

        return new Promise((resolve, reject) => {
            QueryComponents.get().then((response) => {
                const component = response.data.components.find(c => c.name.toLowerCase() === type.toLowerCase())

                QueryIncidents.get({ componentId : component.id }).then((response) => {
                    commit('SET_INCIDENTS', response.body)
                    commit('SET_COMPONENT', component)
                    commit('SET_IS_LOADING', false)
                    resolve(response.body)
                }, (error) => {
                    commit('SET_IS_LOADING', false)
                    reject(error.body)
                })
            }, (error) => {
                commit('SET_IS_LOADING', false)
                reject(error.body)
            })
        })
    },
    updateIncident: ({ commit, getters }, incident) => {
        Vue.http.headers.common.Authorization = getters.getAuthenticationHeader
        commit('SET_IS_LOADING', true)

        return new Promise((resolve, reject) => {
            QueryIncident.update({ id: incident.id }, incident).then((response) => {
                commit('SET_IS_LOADING', false)
                resolve(response.body)
            }, (errorResponse) => {
                commit('SET_IS_LOADING', false)
                reject(errorResponse.body)
            })
        })
    },
    deleteIncident: ({ commit, getters }, incidentId) => {
        Vue.http.headers.common.Authorization = getters.getAuthenticationHeader
        commit('SET_IS_LOADING', true)

        return new Promise((resolve, reject) => {
            QueryIncident.delete({ id: incidentId }).then((response) => {
                commit('SET_IS_LOADING', false)
                resolve(response.body)
            }, (error) => {
                commit('SET_IS_LOADING', false)
                reject(error.body)
            })
        })
    },
    loadReportData: ({ commit }, params) => {
        commit('SET_IS_LOADING', true)

        return new Promise((resolve, reject) => {
            QueryReport.get(params).then((response) => {
                commit('SET_REPORT_DATA', response.body)
                commit('SET_IS_LOADING', false)
                resolve(response.body)
            }, (error) => {
                commit('SET_IS_LOADING', false)
                reject(error.body)
            })
        })
    },
    createNewIncident: ({ commit, getters }, incident) => {
        Vue.http.headers.common.Authorization = getters.getAuthenticationHeader
        commit('SET_IS_LOADING', true)

        return new Promise((resolve, reject) => {
            QueryIncident.save(incident).then((response) => {
                commit('SET_IS_LOADING', false)
                resolve(response.body)
            }, (errorResponse) => {
                commit('SET_IS_LOADING', false)
                reject(errorResponse.body)
            })
        })
    },
    addNewMessage: ({ commit, getters }, message) => {
        Vue.http.headers.common.Authorization = getters.getAuthenticationHeader
        commit('SET_IS_LOADING', true)

        return new Promise((resolve, reject) => {
            QueryMessages.save(message).then((response) => {
                commit('SET_IS_LOADING', false)
                resolve(response.body)
            }, (errorResponse) => {
                commit('SET_IS_LOADING', false)
                reject(errorResponse.body)
            })
        })
    },
    updateMessage: ({ commit, getters }, message) => {
        Vue.http.headers.common.Authorization = getters.getAuthenticationHeader
        commit('SET_IS_LOADING', true)

        return new Promise((resolve, reject) => {
            QueryMessages.update({ id: message.id }, message).then((response) => {
                commit('SET_IS_LOADING', false)
                resolve(response.body)
            }, (errorResponse) => {
                commit('SET_IS_LOADING', false)
                reject(errorResponse.body)
            })
        })
    },
    deleteMessage: ({ commit, getters }, messageId) => {
        Vue.http.headers.common.Authorization = getters.getAuthenticationHeader
        commit('SET_IS_LOADING', true)

        return new Promise((resolve, reject) => {
            QueryMessages.delete({ id: messageId }).then((response) => {
                commit('SET_IS_LOADING', false)
                resolve(response.body)
            }, (errorResponse) => {
                commit('SET_IS_LOADING', false)
                reject(errorResponse.body)
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/actions.js